import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CallProvider } from './contexts/CallContext';
import CallOverlay from './components/calls/CallOverlay';
import AppRoutes from './components/AppRoutes';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { authAPI } = await import('./utils/api');
        await authAPI.getMe();
        setIsAuthenticated(true);
      } catch {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0F14] flex items-center justify-center">
        <div className="text-[#CCFF00] text-xl">Loading...</div>
      </div>
    );
  }

  return (
    <>
      <CallProvider isAuthenticated={isAuthenticated}>
        <BrowserRouter>
          <AppRoutes isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
          <CallOverlay />
        </BrowserRouter>
      </CallProvider>
      <Toaster position="top-right" theme="dark" />
    </>
  );
}

export default App;
